import { ThemeColorModes } from '@atlaskit/tokens';

import { store as atlassianStore } from 'src/utils/atlassian-store';

import { Blog } from './components/blog-fetch';

export function clearAll() {
  atlassianStore.clearAll();
}

// Whats new content
const contentStorageKey = (userUuid: string) => `whatsnew_content::${userUuid}`;

export const lastSeenStorageKey = (userUuid: string) => `whatsnew::${userUuid}`;

export const getLastSeen = (userUuid: string) =>
  atlassianStore.get(lastSeenStorageKey(userUuid), 0);

export const setLastSeen = (userUuid: string, latestBlogId: number) =>
  atlassianStore.setStrictlyNecessaryItem(
    lastSeenStorageKey(userUuid),
    latestBlogId
  );

export const getContent = (userUuid: string) =>
  atlassianStore.get(contentStorageKey(userUuid));

export const setContent = (userUuid: string, blogs: Blog[]) => {
  const oneHourExpiry = new Date().getTime() + 60 * 60 * 1000;
  atlassianStore.setStrictlyNecessaryItem(
    contentStorageKey(userUuid),
    blogs,
    oneHourExpiry
  );
};

// Theme Selector
export const userGlobalThemeKey = 'user-global-theme';

export const setColorTheme = (theme: ThemeColorModes) =>
  atlassianStore.setStrictlyNecessaryItem(userGlobalThemeKey, theme);

export const getColorTheme = (): ThemeColorModes =>
  atlassianStore.get(userGlobalThemeKey);
